import { useContext } from 'react';
import styled from '@emotion/styled';
import { ChartInfoContext, ChartViewContext } from './context';
import { ChartFilterPane } from './Chat.Chart.Settings';
import { ChartViewButton, TableViewButton } from './Chat.Chat.ViewToggle';
import { ChartDataTable } from './Chat.ChartDataTable';

interface ChartViewContainerProps {
  renderChart: () => React.ReactNode;
  chartType: string;
}

export function ChartViewContainer({ renderChart, chartType }: ChartViewContainerProps) {
  const [viewMode, setViewMode] = useContext(ChartViewContext);
  const [chart] = useContext(ChartInfoContext);

  return (
    <>
      <ChartHeader>
        <Title>{chart.chart.chart.title}</Title>
        <ButtonGroup>
          <TableViewButton
            onClick={() => setViewMode('table')}
            viewMode="table"
            isActive={viewMode === 'table'} />

          <ChartViewButton
            onClick={() => setViewMode('chart')}
            viewMode="chart"
            isActive={viewMode === 'chart'} />

          {chartType !== 'line' && chartType !== 'multiple-line' && <ChartFilterPane />}
        </ButtonGroup>
      </ChartHeader>

      {viewMode === 'chart' ? (
        renderChart()
      ) : (
        <ChartDataTable
          data={chart.chart.chart.data}
          chartData={chart}
          chartType={chartType} />
      )}
    </>
  );
}

const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;

const Title = styled.div(({ theme }) => ({
  fontFamily: theme.fonts.semiBold,
}));

const ButtonGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;